<template>

  <div>
<!--    <dv-full-screen-container style="background-color: #ffffff;">-->

        <!--面包屑菜单-->
        <div class="app-title">
          <em-view-title key="viewTitle"></em-view-title>
        </div>


      <div class="acct-mainboard">
        <div>
          <p class="dv-card-title" style="font-size: 2rem;">设备故障记录统计分析</p>
          <p style="color: #666666;">Accident statistical analysis</p>

        </div>

        <div class="echart-borad-row-title">
          <div style="width: 40%; background-color: #ffffff;margin-left: -70px;">
            <YearPicker v-model="year"></YearPicker>
          </div>
          <div style="width: 40%; background-color: #ffffff;">

          </div>
        </div>

        <div class="echart-borad-row1">
          <div style="width: 40%; background-color: #eeeeee;margin-right: 30px;">
            <chartType style="height: 100%" :id="id1" :year="year"></chartType>
          </div>

          <div style="width: 40%; background-color: #eeeeee;">
            <chartMonth style="height: 100%" :id="id2" :year="year"></chartMonth>
          </div>
        </div>

        <div class="echart-borad-row2">
          <div style="width: 40%; background-color: #eeeeee;margin-right: 30px;">
            <chartLevel style="height: 100%" :id="id3" :year="year"></chartLevel>
          </div>

          <div style="width: 40%; background-color: #eeeeee;">
            <chartDept style="height: 100%" :id="id4" :year="year"></chartDept>
          </div>
        </div>
      </div>
<!--  </dv-full-screen-container>-->

  </div>

</template>
<script>
// Author thq
// Date 2021-06-09 10:52:42

import EmCommonApi from "@/mixin/em/common/api";
import chartType from "./charts/chartType";
import chartMonth from "./charts/chartMonth";
import chartLevel from "./charts/chartLevel";
import chartDept from "./charts/chartDept";
import YearPicker from './charts/YearPicker';
import EmViewTitle from "@/components/em/EmViewTitle/index";

//import screenfull from 'screenfull'

export default {
  name: "emAcctStatistics",
  components:{chartType,chartMonth,chartLevel,chartDept,YearPicker,EmViewTitle},
  mixins: [EmCommonApi],

  data(){
    return{
      id1: "echarts_type",
      id2: "echarts_month",
      id3: "echarts_level",
      id4: "echarts_dept",
      year:"",
      fresh: {},

    }
  },
  created() {
    //初始化页面全屏
    // if (!screenfull.isFullscreen) {
    //   screenfull.toggle()
    // }

    //初始化年份，这里屏蔽，在子组件自己初始化自己的初始查询年份
    //this.year = new Date().getFullYear();
  },

  mounted() {
    //定时轮巡查询
    //this.fresh = setInterval(() => {
    //   this.getRemoteData();
    //   window.addEventListener('resize', this.chart.resize, false)
    // },  10000);
  },
  beforeDestroy() {
    //必须销毁，否则浏览器会崩溃
    //clearInterval(this.fresh)
    //window.removeEventListener('resize', this.chart.resize, false)
  },
  methods:{
  }
};
</script>

<style scoped>

.acct-mainboard{
  margin: 115px 1% 2% 3%;   /*上 右 下 左*/
  padding: 10px;
  background-color: #ffffff;
  border-radius: 10px;
}

.echart-borad-row-title{
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 50px;
}

.echart-borad-row1{
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 400px;
}

.echart-borad-row2{
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 30px;
  height: 400px;
}

.dv-card-title {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 1.5rem;
  color: #7ec699;
  font-weight: 700;
  margin: auto 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
